export const GET_EMPLOYEES_SUCCESS = 'GET_EMPLOYEES_SUCCESS';
export const GET_EMPLOYEES_WITH_EXPENSES_FOR_TAX_YEAR_SUCCESS = 'GET_EMPLOYEES_WITH_EXPENSES_FOR_TAX_YEAR_SUCCESS';
export const GET_EMPLOYEE_FILTER_SUCCESS = 'GET_EMPLOYEE_FILTER_SUCCESS';
export const SELECT_EMPLOYEE = 'SELECT_EMPLOYEE';
export const SET_SELECTED_EMPLOYEE_FIELD = 'SET_SELECTED_EMPLOYEE_FIELD';